import React, { useCallback, useMemo } from "react";

import { useI18n } from "../../../../hooks/i18n-hooks";

import VStack from "../../../../ui_atoms/VStack";
import ScreenCard, { ButtonType } from "../../../../screens/ScreenCard";

import { StackScreenProps } from "@react-navigation/stack";
import { IJMEditorStackParamList } from "../types";
import { useIJMEditorContext } from "../context";
import ListItem from "../../../../ui_atoms/ListItem";
import { getPayFirstDaysChoices } from "../helper";
import { BodyMediumText, TitleMediumText } from "../../../FormattedText";
import Gap from "../../../../ui_atoms/Gap";
import Separator from "../../../../ui_atoms/separator";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { Buildable } from "ts-essentials";
import { IjmSelection } from "../../../../utils";
type WaitingSelectScreenProps = StackScreenProps<IJMEditorStackParamList, "WaitingSelect">;

const WaitingSelectScreen: React.FC<WaitingSelectScreenProps> = ({ navigation }) => {
    const i18n = useI18n();
    const { selection, setSelection } = useIJMEditorContext();

    const onCancel = useCallback(() => {
        navigation.goBack();
    }, [navigation]);

    const ijmChoices = useMemo(() => {
        return getPayFirstDaysChoices().map((x) => ({
            label: i18n.t(x.label),
            value: x.value,
        }));
    }, [i18n]);

    const buttons = useMemo<ButtonType[]>(() => {
        return [
            {
                title: i18n.t("close"),
                onPress: onCancel,
                mode: "outlined",
                isValid: true,
            },
        ];
    }, [i18n, onCancel]);

    const insets = useSafeAreaInsets();

    return (
        <ScreenCard style={{ paddingTop: insets.top }} buttons={buttons}>
            <VStack>
                <Gap gap={0.5} />
                <VStack h="2/3">
                    <TitleMediumText>{i18n.t("ijm.editor.waiting_select.title")}</TitleMediumText>
                    <Gap gap={1} />
                    <BodyMediumText>{i18n.t("ijm.editor.waiting_select.text_1")}</BodyMediumText>
                    <Gap gap={1} />
                    <TitleMediumText>{i18n.t("ijm.editor.waiting_select.title_2")}</TitleMediumText>
                </VStack>
                <Separator top={1 / 2} />
                {ijmChoices.map((ijmChoice) => (
                    <ListItem
                        key={`${ijmChoice.value}`}
                        title={ijmChoice.label}
                        selectable
                        checked={ijmChoice.value === selection.ijmPayFirstDays}
                        onPress={() => {
                            setSelection((prev: Buildable<IjmSelection>) => ({
                                ...prev,
                                ijmPayFirstDays: ijmChoice.value,
                            }));
                            navigation.goBack();
                        }}
                    />
                ))}
            </VStack>
        </ScreenCard>
    );
};

export default WaitingSelectScreen;
